import { safeLocalStorage } from '@toss/storage';

/**
 * 인증 왕복 동안 복사 의도를 기다리는 시간. 가입까지 끝내고 돌아오는 사용자를 놓치지 않을 만큼 잡는다.
 * 경험적 초기값이다.
 */
const COPY_INTENT_TTL_MS = 30 * 60 * 1000;

const intentKey = (sourceQuizsetId: string) =>
  `quiz-copy-intent:${sourceQuizsetId}`;

/**
 * "이 사용자가 방금 이 퀴즈의 `복사하기` 를 눌렀다"는 1회용 표식.
 *
 * 표식 없이 자동 복사하면 두 가지가 샌다.
 *  - 안내 화면에서 새로고침하면 복사본이 또 생긴다
 *  - 누군가 퍼뜨린 `/copy/{id}` 링크를 열기만 해도 그 계정에 복사된다
 *
 * 표식은 같은 오리진 localStorage 에 둔다.
 */
export const saveCopyIntent = (sourceQuizsetId: string) => {
  safeLocalStorage.set(
    intentKey(sourceQuizsetId),
    String(Date.now() + COPY_INTENT_TTL_MS),
  );
};

/**
 * 표식을 꺼내며 지운다. 유효하면 `true` — 한 번만 `true` 를 돌려주므로 새로고침은 `false` 다.
 */
export const consumeCopyIntent = (sourceQuizsetId: string): boolean => {
  const key = intentKey(sourceQuizsetId);
  const expiresAt = Number(safeLocalStorage.get(key));
  safeLocalStorage.remove(key);
  return Number.isFinite(expiresAt) && expiresAt > Date.now();
};
